import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-3123">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3124">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-3125" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-3126">
        <div className="max-w-3xl mx-auto text-center" data-id="element-3127">
          <div className="flex justify-center mb-5" data-id="element-3128">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3129">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-3130" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-3131">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-3132">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-3133">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-3134" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-3135">
        {/* IMPORTANT WARNING */}
        <section data-id="element-3136">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-3137">
            <div className="flex items-start gap-4" data-id="element-3138">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-3139">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-3140" />
              </div>
              <div data-id="element-3141">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-3142">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-3143">
                  Estás A <span className="font-black text-white" data-id="element-3144">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-3145">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-3146">
          <div className="text-center mb-8" data-id="element-3147">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-3148">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3149" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-3150">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-3151">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3152">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3153">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3154" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3155">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-3156">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3157">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3158">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3159" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3160">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-3161">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3162">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3163">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3164" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3165">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-3166">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-3167">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3168">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3169" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3170">
                <span className="font-bold text-white" data-id="element-3171">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-3172">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-3173">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-3174" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-3175">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-3176">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-3177">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-3178">
            <div className="flex items-center gap-3 mb-8" data-id="element-3179">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-3180">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3181" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-3182">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-3183">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-3184">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-3185">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3186">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-3187" />
                </div>
                <div data-id="element-3188">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3189">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3190">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-3191">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3192">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-3193" />
                </div>
                <div data-id="element-3194">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3195">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3196">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-3197">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3198">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-3199" />
                </div>
                <div data-id="element-3200">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3201">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3202">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-3203">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-3204">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-3205" />
                </div>
                <div data-id="element-3206">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-3207">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-3208">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-3209">
          <div className="text-center mb-8" data-id="element-3210">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-3211">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-3212" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-3213">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-3214">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3215">
              <div className="flex gap-1 mb-4" data-id="element-3216">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3217" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3218" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3219" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3220" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3221" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3222" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3223">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3224">
                <p className="font-bold text-white text-sm" data-id="element-3225">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-3226">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3227">
              <div className="flex gap-1 mb-4" data-id="element-3228">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3229" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3230" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3231" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3232" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3233" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3234" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3235">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3236">
                <p className="font-bold text-white text-sm" data-id="element-3237">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-3238">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-3239">
              <div className="flex gap-1 mb-4" data-id="element-3240">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3241" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3242" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3243" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3244" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-3245" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-3246" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-3247">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-3248">
                <p className="font-bold text-white text-sm" data-id="element-3249">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-3250">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-3251">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-3252">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-3253" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-3254">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-3255" />
      <WhatsAppButton data-id="element-3256" />
    </div>;
}